(function () {
  function initSlider(slider) {
    // Prevent double-binding (Shopify editor reloads sections)
    if (slider.dataset.ba3Inited === "1") return;
    slider.dataset.ba3Inited = "1";

    const setPos = (x) => {
      const r = slider.getBoundingClientRect();
      let p = (x - r.left) / r.width;
      p = Math.max(0.02, Math.min(0.98, p));
      slider.style.setProperty("--pos", p);
    };

    let sx = 0, sy = 0, decided = false, dragging = false;
    let activePointerId = null;

    const onDown = (e) => {
      sx = e.clientX;
      sy = e.clientY;
      decided = false;
      dragging = false;
      activePointerId = e.pointerId;

      const onMove = (ev) => {
        if (!decided) {
          const dx = Math.abs(ev.clientX - sx);
          const dy = Math.abs(ev.clientY - sy);

          if (dx > 6 || dy > 6) {
            decided = true;

            if (dx > dy) {
              dragging = true;
              try { slider.setPointerCapture(activePointerId); } catch (_) {}
              ev.preventDefault();
            } else {
              cleanup();
              return;
            }
          } else {
            return;
          }
        }

        if (dragging) {
          ev.preventDefault();
          setPos(ev.clientX);
        }
      };

      const onUp = () => cleanup();

      const cleanup = () => {
        slider.removeEventListener("pointermove", onMove, { passive: false });
        slider.removeEventListener("pointerup", onUp);
        slider.removeEventListener("pointercancel", onUp);

        if (activePointerId !== null) {
          try { slider.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
      };

      slider.addEventListener("pointermove", onMove, { passive: false });
      slider.addEventListener("pointerup", onUp);
      slider.addEventListener("pointercancel", onUp);
    };

    slider.addEventListener("pointerdown", onDown, { passive: true });

    // init center once
    const r = slider.getBoundingClientRect();
    setPos(r.left + r.width / 2);
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-ba3-slider]").forEach(initSlider);
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));

document.addEventListener("shopify:section:load", (event) => {
  initAll(event.target);
});
})();
